const value = {
    title: 'Данной страницы не существует',
    message: 'Запрошенный объект не найден',
    button: 'На главную',
  };

export default value;
